// Copyright 2021 Sorama B.V.

export class InvalidRouteView {}
